import React from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker } from 'react-dates';

import { onClickWrapper } from '../../../utils/ui';

export default ({ id, onDatesChange, ...props }) => (
  <DateRangePicker
    onDatesChange={onClickWrapper(id, onDatesChange)}
    {...props}
  />
);
